import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { NAV_MODULES, NavModule } from '../../../core/nav.config';

const DEFAULT_ROUTES = ['/dashboard', '/grabpflege', '/kalender', '/auftragseingang', '/einstellungen'];

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, RouterLinkActive],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private auth = inject(AuthService);

  readonly navItems = computed((): NavModule[] => {
    let routes: string[];
    try {
      const saved = JSON.parse(this.auth.user()?.nav_items ?? 'null');
      if (saved && Array.isArray(saved)) {
        // Einstellungen rausfiltern, dann max. 4 nehmen, dann Einstellungen fest anhängen
        routes = [
          ...saved.filter((r: string) => r !== '/einstellungen').slice(0, 4),
          '/einstellungen',
        ];
      } else {
        routes = DEFAULT_ROUTES;
      }
    } catch {
      routes = DEFAULT_ROUTES;
    }

    return routes
      .map(route => NAV_MODULES.find(i => i.route === route))
      .filter((i): i is NavModule => !!i)
      // Nur Module zeigen, für die Berechtigung besteht (module=null = immer sichtbar).
      .filter(i => !i.module || this.auth.can(i.module));
  });
}
